import { defineStore } from "pinia";
import Services from '@/services/sutting/positionsServices'
import { mapList, mapPosition } from '@/helpers/mapFuncs'

export const usePositionsStore = defineStore("positions", {
persist: true,
state:()=>({
    position: {},
    positions: [],
}),
getters : {
    getPosition() {
        return mapPosition(this.position)
    },
    getPositions() {
        return this.positions.map(mapPosition)
    },
    getPositionsList() {
        return this.positions.map((item) => ({
            ...mapList(item),
            level: item?.level ?? null,
        }))
    }
},
actions : {
    /** Start Sets */
    setPosition(position) {
        this.position = position
    },
    setPositions(positions) {
        this.positions = positions
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setPosition(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setPositions(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.positions.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.positions[this.positions.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.positions = this.positions.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
